'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { safeSmoothScrollTo } from '../../../utils/utils';

const ContentItem = ({
  url,
  heading,
  subheading
}) => {
  const location = useLocation();
  return /*#__PURE__*/_jsxs(UIRouterLink, {
    className: "lesson-content-item",
    "data-test-id": "lesson-content-item",
    onClick: () => {
      safeSmoothScrollTo(window, 0, 0);
    },
    to: Object.assign({}, location, {
      pathname: url
    }),
    use: "unstyled",
    children: [/*#__PURE__*/_jsx("div", {
      className: "lesson-content-item__heading",
      children: heading
    }), /*#__PURE__*/_jsx("div", {
      className: "lesson-content-item__subheading",
      children: subheading
    })]
  });
};

ContentItem.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  subheading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  url: PropTypes.string.isRequired
};
export default ContentItem;